const navigationEn = {
  menu: {
    tiendas: 'Stores',
    clientes: 'Clients',
    packaging: 'Packaging',
    warehouse_material: 'Warehouse material',
    puestos_trabajo: 'Workstations',
    productos: 'Products',
    productos_main: 'Products',
    productos_packs: 'Packs',
    crm: 'CRM',
    reportes: 'Reports',
    rentabilidad_section: 'Profitability',
    profitability_overview: 'Overview',
    profitability_ad_spend: 'Ad spend',
    profitability_product_costs: 'Product costs',
    profitability_shipping_costs: 'Shipping costs',
    productos_sin_stock: 'Products without stock',
    pedidos: 'Orders',
    pedidos_main: 'Orders',
    pedidos_preparar: 'Orders to prepare',
    pedidos_enviados: 'Shipped orders',
    billeteras: 'Wallet',
    retiros: 'Withdrawals',
    payment_files: 'Payment files',
    billeteras_main: 'Wallets',
    cuentas_bancarias: 'Bank accounts',
    recargas: 'Topups',
    wallets_accounting_sync: 'Holded accounting',
    ordenes_ubicacion: 'Location orders',
    preparar_pedidos: 'Order preparation',
    orders: 'Orders',
    preparaciones: 'Preparations',
    manifests: 'Manifests',
    packs: 'Packs',
    trabajos_extra: 'Extra work',
    ubicaciones: 'Locations',
    carritos: 'Carts',
    almacen: 'Warehouse',
    almacen_configuracion: 'Configuration',
    almacen_grupo: 'Warehouse',
    almacen_ordenes_ubicacion: 'Location orders',
    almacen_ubicaciones: 'Locations',
    almacen_carritos: 'Carts',
    almacen_reubicar: 'Relocate',
    lotes: 'Batches',
    almacen_informes: 'Reports',
    ready_to_prepare_by_hour: 'Orders by hour',
    merchandise: 'Merchandises',
    receptions: 'Receptions',
    entradas: 'Entries',
    entradas_recepciones: 'Receptions',
    entradas_trabajos_extra: 'Extra work',
    entradas_rehusados: 'Rejected',
    entradas_mercancias: 'Customer merchandise',
    movimientos: 'Movements',
    movimientos_stock: 'Stock',
    movimientos_ubicaciones: 'Locations',
    rehusados: 'Rejected',
    incidencias: 'Incidents',
    incidencias_main: 'Incidents',
    mapeos: 'Incident Mapping',
    configuracion: 'Settings',
    backToApp: 'Back to app',
    configSectionAccount: 'Account',
    configSectionTeam: 'Team',
    configSectionAdmin: 'Administration',
    empresa: 'Company',
    perfil: 'Profile',
    suscripcion: 'Subscription',
    logout: 'Log out',
    workspace: 'Workspace',
    printers: 'Printers',
    search_printer: 'Search printer',
    general: 'General',
    impresoras: 'Printers',
    mensajerias: 'Shipping',
    rules: 'Shipping rules',
    shippingRulePresets: 'Shipping Rule Presets',
    packagingRulesets: 'Packaging rules',
    coverageZones: 'Coverage Zones',
    shipmentStatusMapping: 'Shipment Status Mapping',
    courierErrorsMapping: 'Courier Errors',
    trackingMonitoring: 'Tracking Monitoring',
    productCategories: 'Product categories',
    integrations: 'Integrations',
    webhooks: 'Webhooks',
    'mi-perfil': 'My profile',
    notificaciones: 'Notifications',
    inicio: 'Home',
    theme: 'Theme',
    themes: {
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    language: 'Language',
    languages: {
      es: 'Español',
      en: 'English',
    },
    titles: {
      stock_movements: 'Stock movements',
      location_movements: 'Location movements',
      integrated_messaging: 'Integrated Messaging',
      rules: 'Shipping rules',
      logistics: 'Logistics',
      profitability: 'Profitability',
      logistic_pivot: 'Logistics metrics',
      inventory: 'Inventory',
      marketing: 'Marketing',
    },
    afiliados: 'Affiliates',
    roles: 'Roles',
    users: 'Users',
    centro_ayuda: 'Help Center',
    contabilidad: 'Accounting',
    facturacion: 'Billing',
    facturacion_pedidos: 'Orders',
    facturacion_almacenamiento: 'Storage',
    facturacion_cuota_minima: 'Minimum fee',
    facturacion_prefacturacion: 'Pre-invoicing',
    facturacion_facturas: 'Invoices',
    facturacion_facturas_courier: 'Courier invoices',
    facturacion_tarifas: 'Rates',
    orders_without_weight: 'Orders without weight',
    three_pl_excel_reports: 'Report export',
    legacy_dashboard: 'Active legacy clients',
    reportes_contabilidad: 'Reports',
    contabilidad_carga_datos: 'Data upload',
    reembolsos_reporte: 'Refund liquidations',
    global_search_placeholder: 'Global search',
    global_search: {
      title: 'Global search',
      mobile_placeholder: 'Search across your entire platform',
      modal_placeholder: 'Search by product, order...',
      result: 'result',
      results: 'results',
      loading: 'Searching...',
      no_results: 'No results found',
      no_results_title: "Oops... We haven't found anything.",
      no_results_description: 'Try again using other search terms',
      no_product: 'No product',
      no_status: 'No status',
      navigate: 'Navigate',
      close: 'Close',
      open: 'Open',
      go: 'Go',
      category: {
        product: 'Product',
        cart: 'In cart',
        entry: 'Entries',
        order: 'Order',
        merchandise: 'Merchandise',
        location: 'Location',
        preparation: 'Preparation',
        returned_reception: 'Returned reception',
      },
    },
    cod_payments: 'COD Payments',
    cod_payouts: 'Payouts',
    cod_payout_items: 'Payout Items',
    cod_courier_files: 'Courier Files',
    cod_mismatches: 'Refund Report',
    packing: 'Packing',
    gestion_popups: 'Popups Management',
    switchTeam: {
      success: {
        title: 'Company switched',
        description: 'Company has been switched successfully',
      },
      error: {
        title: 'Error switching company',
        unexpected: 'Unexpected error switching company. Please try again.',
      },
    },
  },
  table: {
    activate: 'Activate',
    deactivate: 'Deactivate',
  },
};

export default navigationEn;
